<template>
  <!-- BESPOKE GOOL-2: Added v-if="filters.length" -->
  <div v-if="filters.length" class="cmp-elastic-product-filters utlz-reset col-md-12">
    <!-- END BESPOKE GOOL-2 -->
    <transition name="slide-fade">
      
      <div v-if="showMobileFilters" class="filters-container" :ref="'filters-container'">
        
        <a v-if="showMobileFilters" @click="toggleMobileFilters()" class="close-filters-btn show-mobile">
          <i class="fa fa-times"></i>
        </a>

        <div v-for="(filterGroup, i) in filters" :key="'filter-group-' + i" class="filters-wrapper">
          
          <div class="filter-header">
            <p>{{ filterGroup.label }}</p>
            <!-- BESPOKE NOX-71: Added fa.angle-down -->
            <i class="dd-arrow fa fa-angle-down"></i>
            <!-- END BESPOKE NOX-71 -->
          </div>
          <div class="filter-content">
            <!-- BESPOKE GOOL-6: Changed 5 to 999 -->
            <ul :ref="'filter-group-list' + i" :class="{ collapsed: filterGroup.value.length > 999 }">
              <!-- END BESPOKE GOOL-6 -->
              <li v-for="(filterObj, id) in filterGroup.value" :key="'filter-group-item-' + id">
                <div class="checkbox-group">
                  <input type="checkbox" :id="'checkbox-filter-' + filterGroup.id + '-' + filterObj.key" @change="checkedFilter($event, { id: filterGroup.id, value: filterObj.key, elemId: 'checkbox-filter-' + filterGroup.id + '-' + filterObj.key })" :checked="filterObj.active === true">
                  <label :for="'checkbox-filter-' + filterGroup.id + '-' +  filterObj.key">
                    <span class="key">
                      {{ filterObj.key }}
                    </span>
                    <span class="count">
                      ({{ filterObj.value }})
                    </span>
                  </label>
                </div>
              </li>
            </ul>
            <!-- BESPOKE GOOL-6: Changed 5 to 999 -->
            <div v-if="filterGroup.value.length > 999" class="collapse-btns" @click="collapseList('filter-group-list' + i)">
            <!-- END BESPOKE GOOL-6 -->
              <div class="show-more-btn">
                <span class="text-link">
                  <i class="fa fa-angle-double-down"></i>
                  <span v-translation="{ type: 'label', code: 'label_filter_collapse_more' }"></span>
                </span>
                <span class="total-collapsed count">({{ filterGroup.value.length - 5 }})</span>
              </div>
              <div class="show-less-btn">
                <span class="text-link">
                  <i class="fa fa-angle-double-up"></i>
                  <span v-translation="{ type: 'label', code: 'label_filter_collapse_less'}"></span>
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
      

    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  data() {
    return {
      movedSortingOptions: false
    }
  },
  computed: {
    ...mapState('elastic', ['filters']),
    ...mapGetters('elastic', ['showMobileFilters'])
  },
  methods: {
    ...mapActions('elastic', ['updateFilters', 'toggleMobileFilters']),
    checkedFilter (ev, filter) {
      const payload = {
        filterActive: ev.target.checked,
        filterId: filter.id,
        filterValue: filter.value
      };
      if (ev.target.checked) {
        document.getElementById(filter.elemId).checked = false;
      } else {
        document.getElementById(filter.elemId).checked = true;
      }
      this.updateFilters(payload);
    },
    collapseList ($event) {
      this.$refs[$event][0].classList.toggle('collapsed');
    }
  }
}
</script>
<style>

</style>
